import(/* webpackMode: "eager" */ "/app/app/components/common/ProductSlider.js");
import(/* webpackMode: "eager" */ "/app/app/styles/components/common/breadcrumbs.module.scss");
import(/* webpackMode: "eager" */ "/app/app/styles/page/our-partners/our-partner.module.scss");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js")